export default __webpack_public_path__ + "static/media/sa.6076fa70.svg";